import { z } from "zod";

// Service Standard Status Enum
export const ServiceStandardStatusSchema = z.enum(["active", "draft", "inactive"]);

// Service Standard Service Stage Enum
export const ServiceStageSchema = z.enum(["before", "during", "after", "all"]);

// Create Service Standard Schema
export const CreateServiceStandardSchema = z.object({
  name: z.string().min(1, "ກະລຸນາໃສ່ຊື່ມາດຕະຖານບໍລິການ"),
  description: z.string().optional().nullable(),
  serviceChannelId: z.string().min(1, "ກະລຸນາເລືອກຊ່ອງທາງບໍລິການ"),
  departmentId: z.string().optional().nullable(),
  positionId: z.string().optional().nullable(),
  serviceStage: ServiceStageSchema.default("all"),
  status: ServiceStandardStatusSchema.default("draft"),
});

export const UpdateServiceStandardSchema = CreateServiceStandardSchema.partial();

// Service Standard Item Form Schema
export const ServiceStandardItemFormSchema = z.object({
  id: z.string().optional(), // For existing items during edit
  itemType: z.enum(["do", "dont"]),
  content: z.string().min(1, "ກະລຸນາໃສ່ເນື້ອໃນ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().min(0),
});

// Service Standard Example Form Schema
export const ServiceStandardExampleFormSchema = z.object({
  id: z.string().optional(), // For existing examples during edit
  situation: z.string().min(1, "ກະລຸນາໃສ່ສະຖານະການ"),
  example: z.string().min(1, "ກະລຸນາໃສ່ຕົວຢ່າງ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().min(0),
});

// Service Standard Special Case Form Schema
export const ServiceStandardSpecialCaseFormSchema = z.object({
  id: z.string().optional(), // For existing special cases during edit
  title: z.string().min(1, "ກະລຸນາໃສ່ຫົວຂໍ້"),
  handling: z.string().min(1, "ກະລຸນາໃສ່ວິທີການຈັດການ"),
  description: z.string().optional().nullable(),
  orderIndex: z.number().int().min(0),
});

// Form schemas (includes nested items)
export const CreateServiceStandardFormSchema = CreateServiceStandardSchema.extend({
  items: z.array(ServiceStandardItemFormSchema).optional(),
  examples: z.array(ServiceStandardExampleFormSchema).optional(),
  specialCases: z.array(ServiceStandardSpecialCaseFormSchema).optional(),
});
export type CreateServiceStandardFormDTO = z.infer<typeof CreateServiceStandardFormSchema>;

export const UpdateServiceStandardFormSchema = UpdateServiceStandardSchema.extend({
  items: z.array(ServiceStandardItemFormSchema).optional(),
  examples: z.array(ServiceStandardExampleFormSchema).optional(),
  specialCases: z.array(ServiceStandardSpecialCaseFormSchema).optional(),
});
export type UpdateServiceStandardFormDTO = z.infer<typeof UpdateServiceStandardFormSchema>;

// Form value types
export type ServiceStandardItemFormDTO = z.infer<typeof ServiceStandardItemFormSchema>;
export type ServiceStandardExampleFormDTO = z.infer<typeof ServiceStandardExampleFormSchema>;
export type ServiceStandardSpecialCaseFormDTO = z.infer<typeof ServiceStandardSpecialCaseFormSchema>;

// Type exports
export type ServiceStandardStatus = z.infer<typeof ServiceStandardStatusSchema>;
export type ServiceStage = z.infer<typeof ServiceStageSchema>;
export type CreateServiceStandardDTO = z.infer<typeof CreateServiceStandardSchema>;
export type UpdateServiceStandardDTO = z.infer<typeof UpdateServiceStandardSchema>;

